import { takeEvery, fork, put, all, call, delay } from "redux-saga/effects"
import { GET_NDA_AGREEMENT, SEND_AGREEMENT_MAIL, UPLOAD_AGREEMENT } from "./Constants"
import { getNdaAgreementApi, SendAgreementMailApi, uploadNdaAgreementApi } from "./api"
import { getNdaAgreementFailed, getNdaAgreementSuccess, uploadNdaAgreementFailed, uploadNdaAgreementSuccess } from "./Actions"

function* uploadNdaAgreementAsync(action) {
    try {
      const response = yield call(uploadNdaAgreementApi, action.payload)
      if (response.status === 200 || 201) {
        yield put(uploadNdaAgreementSuccess(response.data.message))
      } else {
        throw response
      }
    } catch (error) {
      yield put(uploadNdaAgreementFailed(error.response.data.message || "Something error Occured please try again"))
    }
  }
  function* uploadNdaAgreement() {
    yield takeEvery(UPLOAD_AGREEMENT, uploadNdaAgreementAsync)
  }


  function* getNdaAgreementAsync() {
    try {
      const response = yield call(getNdaAgreementApi)
      if (response.status === 200 || 201) {
        yield put(getNdaAgreementSuccess(response.data.fileUrl))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getNdaAgreementFailed(error.response.data.message || "Something error Occured please try again"))
    }
  }
  function* getNdaAgreementSaga() {
    yield takeEvery(GET_NDA_AGREEMENT, getNdaAgreementAsync)
  }


  function* sendAgreementMailAsync() {
    try {
      const response = yield call(SendAgreementMailApi)
      if (response.status === 200 || 201) {
        yield put(getNdaAgreementSuccess(response.data.fileUrl))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getNdaAgreementFailed(error.response.data.message || "Something error Occured please try again"))
    }
  }
  function* sendAgreementMailSaga() {
    yield takeEvery(SEND_AGREEMENT_MAIL, sendAgreementMailAsync)
  }

  function* NdaAgreementSaga() {
    yield all([
      fork(uploadNdaAgreement),
      fork(getNdaAgreementSaga),
      fork(sendAgreementMailSaga),
    ])
  }
  export default NdaAgreementSaga